import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText } from '../style'

const ValidationProposalModal = ({ toggleModal, sections, onContinue }) => {
  const sectionsText = Array.isArray(sections) ? sections.join(', ') : ''

  const closeModal = () => {
    toggleModal(false)
    if (typeof onContinue === 'function') {
      onContinue()
    }
  }

  return (
    <div>
      <ValidationProposalModalText>
        Further details are required before you can propose this assessment. Please review and complete the empty fields
        that are mandatory in the following pages: <b> {sectionsText}</b>
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="primary" onClick={closeModal}>
          <FormattedMessage id="continueEditing" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default ValidationProposalModal

ValidationProposalModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
  onContinue: PropTypes.func
}
